import JobDetail from './styled';

export default JobDetail;
